import { Redirect, RouteComponentProps, Router } from '@reach/router';
import React, { ComponentType } from 'react';
import { Editor } from './detail/editor/editor.component';
import { List } from './list/list.component';

export const Season: ComponentType<RouteComponentProps> = (props) => {
  return (
    <>
      <Router className="router">
        <List path="list" />
        <Editor path=":id/edit" mode="update" />
        <Editor path="create" mode="create" />
        <Redirect noThrow from="/" to="list" />
      </Router>
    </>
  );
};
